import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function CountdownSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'HRS'
  }, {
    value: minutes,
    label: 'MIN'
  }, {
    value: seconds,
    label: 'SEC'
  }];
  return <section className="w-full bg-ink px-5 pb-16 sm:px-8" data-id="element-57" data-mp="39s3woh5af6ev">
      <div className="mx-auto w-full max-w-3xl overflow-hidden rounded-2xl border border-ember/60 bg-card" data-id="element-58" data-mp="39uq2ab8mbbug">
        <div className="h-1 w-full bg-gradient-to-r from-ember via-orange-500 to-amber-400" data-id="element-59" data-mp="3nq1vufb1ew9s" />
        <div className="px-6 py-10 text-center sm:px-10" data-id="element-60" data-mp="3ir7frl4gfltd">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-ember" data-id="element-61" data-mp="1bsakf2em4d8">
            ⏰ Limited-time offer
          </p>
          <h2 className="mt-3 text-2xl font-extrabold text-white sm:text-3xl" data-id="element-62" data-mp="3sl7r44qbxnaj">
            The launch price ends in:
          </h2>

          <div className="mt-6 flex items-start justify-center gap-2 sm:gap-4" role="timer" aria-live="off" data-id="element-63" data-mp="5excafenu20t">
            {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-64" data-mp="1ikkuyfosz0s0" data-mpi={index}>
                {index > 0 && <span aria-hidden="true" className="text-4xl font-extrabold text-ember sm:text-6xl" data-id="element-65" data-mp="1nk7aivs3st3z">
                    :
                  </span>}
                <div data-id="element-66" data-mp="1wlnjcz39sn63">
                  <p className="text-4xl font-extrabold tabular-nums text-ember sm:text-6xl" data-id="element-67" data-mp="1wk40r1u56015">
                    {unit.value}
                  </p>
                  <p className="mt-1 text-[11px] font-bold uppercase tracking-[0.18em] text-neutral-400" data-id="element-68" data-mp="26ap2gy543koa">
                    {unit.label}
                  </p>
                </div>
              </React.Fragment>)}
          </div>

          <p className="mt-8 text-base font-bold text-white" data-id="element-69" data-mp="2ga63315ib8de">
            When that's over, the price goes up and the bonuses are removed.
          </p>

          <div className="mt-8" data-id="element-70" data-mp="l5pzo7nse1v9">
            <div className="h-2 w-full overflow-hidden rounded-full bg-neutral-800" data-id="element-71" data-mp="l6rl962fi6r8">
              <div className="h-full rounded-full bg-gradient-to-r from-ember via-orange-500 to-amber-400" style={{
              width: '72%'
            }} data-id="element-72" data-mp="g755aov7uceq" />
            </div>
            <div className="mt-3 flex items-center justify-between text-[11px] font-bold uppercase tracking-[0.1em]" data-id="element-73" data-mp="p6ry4m9vq9w6">
              <span className="text-ember" data-id="element-74" data-mp="13v4zxzvnemyl">🔴 Limited spots</span>
              <span className="text-neutral-300" data-id="element-75" data-mp="yxd5oz7j6or8">72% claimed</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}